<template>
  <div id="app" style="min-height: 100%">
    <v-app id="ukpl" class="cppsbg">
      <router-view />
      <EmailVerificationDialog />
    </v-app>
  </div>
</template>

<style>
/* See assets main.css */
/* Force text input cursors to be visible globally on dark themes */
.v-application .theme--dark.v-text-field input,
.v-application .theme--dark.v-textarea textarea,
.v-application .theme--dark.v-text-field textarea,
.v-text-field input {
  caret-color: white !important;
}
</style>

<script>
import EmailVerificationDialog from "./components/EmailVerificationDialog.vue";

export default {
  name: "App",
  components: {
    EmailVerificationDialog
  },
  data: () => ({}),
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    logOut() {
      console.log("logging out");
      this.$store.dispatch("auth/logout");
      this.$router.push("/home");
    },
  },
};
</script>
